import { Link } from "@/lib/page-rendering"
import { BookOpen, Users } from "lucide-react"
import { useTranslation } from "react-i18next"

import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"
import type SearchShortlistsShortlistWorkspace from "@/types/serializers/SearchShortlistsShortlistWorkspace"

export type ShortlistWorkspaceTab = "classes" | "educators"

/**
 * Switches between a shortlist's two tab pages. Each trigger is a real link
 * to the sibling path and carries that kind's direct count, so a removal
 * shows in the tab once the page returns.
 */
export function ShortlistWorkspaceTabs({
  active,
  shortlist,
}: {
  active: ShortlistWorkspaceTab
  shortlist: SearchShortlistsShortlistWorkspace
}) {
  const { t } = useTranslation("shortlists")

  return (
    <Tabs value={active} data-testid="shortlist-workspace-tabs">
      <TabsList className="h-auto flex-wrap">
        <TabsTrigger value="classes" asChild>
          <Link href={`/search/shortlists/${shortlist.id}/classes`}>
            <BookOpen />
            {t("workspace.tabs.classes", { count: shortlist.class_count })}
          </Link>
        </TabsTrigger>
        <TabsTrigger value="educators" asChild>
          <Link href={`/search/shortlists/${shortlist.id}/educators`}>
            <Users />
            {t("workspace.tabs.educators", {
              count: shortlist.educator_count,
            })}
          </Link>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  )
}
